/**
 * URL param the list-detail page uses to hand a lead to its own leads table: "go to this lead and
 * open its panel on the Chat view".
 *
 * It exists because the writer and the reader are on opposite sides of the page. The AI-drafts queue
 * pill sits in the header (`ListDetailStatusGroup`) and names a lead that may be on a different tab
 * or a different page of the table, so a callback into the table would only work for a lead already
 * in view. A param survives the remount a tab switch causes, which is what lets the jump finish.
 *
 * Written by `ListDetailStatusGroup`, consumed (and cleared) by `useReachOutColumnWiring`.
 */
export const CHAT_LIST_PERSON_PARAM = "chatListPersonId";
